module.exports = __webpack_public_path__ + "static/media/30-13.8628e2c0.mp3";